export default __webpack_public_path__ + "static/media/spiderimg.97fe687b.PNG";